import type { QueryPlaylistInput, PlaylistSort, SortDirection } from '@scio3/shared-types';
import { MODES } from '@scio3/shared-types';
import type { PlaylistSortField } from '../stores/playlist-filter-store';

interface PlaylistFilterState {
  searchText: string;
  searchScope: 'all' | 'folder';
}

/**
 * Converts playlist filter store state to GraphQL QueryPlaylistInput.
 * Note: 'shared' mode is handled at the hook level (useSharedFolders), not here.
 */
export function buildPlaylistQueryInput(
  filters: PlaylistFilterState,
  currentPath: string | null,
  teamId?: string,
): QueryPlaylistInput {
  const query: QueryPlaylistInput = {};

  // Path filter — null for root (only root-level playlists), string for subfolder.
  // When searching with scope 'all', omit path to search globally.
  // query.teamId is coupled with path — only set when path is truthy.
  if (filters.searchText && filters.searchScope === 'all') {
    // No path filter — search across all folders
  } else if (currentPath && currentPath !== '/' && currentPath !== MODES.SHARE_WITH_ME) {
    query.path = currentPath;
    if (teamId) query.teamId = teamId;
  } else {
    query.path = null;
  }

  // Search text → name regex
  if (filters.searchText) {
    query.name_regex = filters.searchText;
  }

  // Note: favoritesOnly is a control flag sent via extendParams at the hook level (not a query
  // field), and the "rest" exclusion is the sibling extendParams.excludeFavorites flag (server-resolved _id $nin).

  return query;
}

/**
 * Converts sort field + direction to GraphQL PlaylistSort.
 */
export function buildPlaylistSortInput(
  sortField: PlaylistSortField,
  sortDirection: SortDirection,
): PlaylistSort {
  return { [sortField]: sortDirection };
}
